import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueGtag from 'vue-gtag'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

Vue.config.productionTip = false;

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    window.addEventListener('beforeunload', (e) => {
      //when redirecting to pay do not show a confirmation dialog
      const isRedirectingToPay = store.getters["missedDelivery/isRedirectingToPay"];
      if (!isRedirectingToPay) {
        // Cancel the event
        e.preventDefault();
        // Chrome requires returnValue to be set to show warning
        e.returnValue = '';
      }
    }, false)
  }
}).$mount('#app')

Vue.use(VueGtag, {
  config: { id: 'G-3YEM6BV27C' }
}, router)